import { render, staticRenderFns } from "./BlocoDadosGeraisTerritorioMonitoramento.vue?vue&type=template&id=5c616097&scoped=true&lang=pug"
import script from "./BlocoDadosGeraisTerritorioMonitoramento.vue?vue&type=script&lang=js"
export * from "./BlocoDadosGeraisTerritorioMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosGeraisTerritorioMonitoramento.vue?vue&type=style&index=0&id=5c616097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c616097",
  null
  
)

export default component.exports